export default class Dropbox {

    constructor(ele, onFileUpload) {
        this.html = ele;
        this.onFileUpload = onFileUpload;

        this.html
            .on("dragenter", this.preventEvent)
            .on("dragover", this.preventEvent)
            .on("dragleave", this.preventEvent)
            .on("click", this.handleClick.bind(this))
            .on("drop", this.handleFileDrop.bind(this));
    }

    handleClick() {
        if(!this.onFileUpload) {
            return;
        }

        const input = document.createElement('input');
        input.type = 'file';
        input.multiple = true;
        input.classList.add('hide');
        input.onchange = e => this.onFileUpload(input.files);

        document.body.appendChild(input);
        input.click();
        document.body.removeChild(input);
    }

    handleFileDrop(evt) {
        this.preventEvent(evt);

        if(!this.onFileUpload) {
            return;
        }

        const files = evt.originalEvent.dataTransfer.files;
        this.onFileUpload(files);
    }

    preventEvent(evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }

}